import constants from "@/common/constants";
import util from "@/common/js/util";
import tempGlobalData from "@/common/js/tempGlobalData";

let data = {};

// noinspection JSIgnoredPromiseFromCall
const dc = {
    dict: function (name) {
        if (data[name]) {
            return data[name];
        }
        if (tempGlobalData[constants.dictStoreKey]) {
            data = tempGlobalData[constants.dictStoreKey]
            return data[name];
        }
        let dataJSON = localStorage.getItem(constants.dictStoreKey);
        if (dataJSON) {
            data = JSON.parse(dataJSON);
            return data[name];
        }
        return [];
    },
    /**
     *
     * @returns
     */
    loadDict: function () {
        let _data = {};
        return util.cache({
            key: constants.dictStoreKey,
            fetch: () => util.axios.get("public/queryDataDictForLogin?companyId="+constants.company.companyId,{loading:false}),
            handle: res => {
                res.module?.forEach(e => {
                    _data[e.name] = e.children;
                });
                data = _data;
                return _data;
            },
            useLocalStorage: false,
        })
    }
}
export default dc;



// WEBPACK FOOTER //
// ./src/common/js/dict.js